module.exports = __webpack_public_path__ + "static/img/1.445d6a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/1.png
// module id = N7uP
// module chunks = 45